import {createTheme} from "@mantine/core";
import {Colors} from "./colors";

export const theme = createTheme({
    // You can still define your color palette or other theme properties here


    components: {
        // 1) Button defaults
        Button: {
            defaultProps: {
                color: Colors.Reinorange,
                variant: 'outline',
            },
        },
        Title: {
            defaultProps: {
                c: Colors.Reinorange
            }
        },
        Text: {
            defaultProps: {
                c: Colors.Telegrau4
            }
        },
        Drawer: {
            defaultProps: {

            },
            styles: () => ({
                // 'root' for the outer container
                content: {
                    // If you want a different outer background, add it here

                },
                // 'root' for the outer container
                header: {
                    // If you want a different outer background, add it here

                }

            }),
        },
        /*TextInput: {
            // defaultProps can set variant, radius, etc. for all TextInputs
            defaultProps: {
                // For example:
                radius: 'md',
                variant: 'filled',
                size: 'md',
            },

            // styles lets you customize each sub-element of TextInput
            // https://mantine.dev/theming/styles-api/#styling-with-create-styles
            styles: () => ({
                // The 'input' selector styles the actual <input> element
                input: {
                    backgroundColor: Colors.Telegrau2,
                    color: Colors.Telegrau4,
                    border: `1px solid ${Colors.Anthrazitgrau}`,

                    // Example of a hover style
                    '&:hover': {
                        borderColor: Colors.Reinorange,
                    },

                    '&:active': {
                        borderColor: "green",
                    },

                    // Disabled styling
                    '&:disabled': {
                        backgroundColor: "white",
                        color: "white",
                    },
                },

                // The 'label' selector styles the label text
                label: {
                    color: Colors.Telegrau4,
                    fontWeight: 500,
                    marginBottom: 4,
                },

                // The 'description' selector styles the helper text under the input
                description: {
                    color: Colors.Reinrot,
                },

                // The 'error' selector styles the error text
                error: {
                    color: Colors.Reinrot,

                },

                // The 'section' selector styles the left/right "section" elements
                section: {
                    color: Colors.Reinorange,
                    // e.g. you could add some spacing or background
                },
            }),
        },*/


        Table: {
            defaultProps: {
                borderColor: Colors.Telegrau2
            },
            styles: () => ({
                // 'root' for the outer container
                thead: {
                    // If you want a different outer background, add it here
                    color: Colors.Telegrau4,
                },
                tbody: {
                    // If you want a different outer background, add it here
                    color: Colors.Telegrau4,

                },
                root: {

                }

            }),
        },
        Divider: {
            defaultProps: {
                color: Colors.Telegrau2
            }
        },
        // 2) AppShell defaults
        AppShell: {
            // Any default props that should apply to all AppShell instances
            defaultProps: {
                padding: 'md',
                header: { height: 60 },
                navbar: { width: 300, breakpoint: 'sm' },
            },

            // Global styles that apply to all <AppShell> usages in your app
            styles: () => ({
                // 'root' for the outer container
                root: {
                    // If you want a different outer background, add it here
                },

                // 'header' for the header region
                header: {
                    backgroundColor: Colors.Anthrazitgrau,
                },

                // 'navbar' for the navbar region
                navbar: {
                    //backgroundColor: Colors.Anthrazitgrau,
                    borderRight: `1px solid ${Colors.Telegrau2}`,
                },

                // 'main' for the main content area
                main: {
                    //backgroundColor: Colors.Anthrazitgrau,
                },
            }),
        },
    },
});